import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";

export default function Navbar() {
  const { user } = useAuth();
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass-nav border-b border-[#D3EEF3]">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <img src="/logo.png" alt="FR Proxies" className="w-8 h-8 rounded-lg object-contain" />
          <span className="font-head font-extrabold tracking-tight text-lg">FR <span className="text-neon">PROXIES</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-600">
          <Link to="/pricing" className="hover:text-neon transition-colors" data-testid="nav-pricing">Pricing</Link>
          <a href="/#products" className="hover:text-neon transition-colors">Products</a>
          <a href="/#faq" className="hover:text-neon transition-colors">FAQ</a>
        </nav>
        <div className="flex items-center gap-3">
          <ThemeToggle className="w-9 h-9 text-zinc-600 hover:text-neon border border-[#D3EEF3] hover:border-neon" />
          {user ? (
            <Link to="/dashboard"><Button className="bg-neon text-base hover:bg-neon-hover font-semibold" data-testid="nav-dashboard-btn">Dashboard</Button></Link>
          ) : (
            <>
              <Link to="/login" className="text-sm text-zinc-700 hover:text-ink transition-colors" data-testid="nav-login">Sign in</Link>
              <Link to="/register"><Button className="bg-neon text-base hover:bg-neon-hover font-semibold" data-testid="nav-signup-btn">Get Started</Button></Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
